module.exports = __webpack_public_path__ + "static/assets/9fef8a4fa40d6b11b7adcc771c9fc2d3.svg";